import { Injectable } from '@angular/core';
import { BaseWsService } from '../../../../core/services/BaseWsService';
import { IWebSocketResponse } from '../../../../core/interfaces/IWebSocketResponse';
import { CinemaWsMethods } from '../enums/CinemaWsMethods';
import { ISeat } from '../../../auditorium/core/interfaces/ISeat';

@Injectable({
  providedIn: 'root'
})
export class CinemaWsService extends BaseWsService {

  protected override readonly hubUrl = '/cinema';
  protected override readonly invokeArguments = [
    this.terminalsStore.changedCinema()?.id ?? this.terminalsStore.selectedTerminal().cinemaId
  ];

  public onSeatStatusChanged(method: (payload: IWebSocketResponse<ISeat>) => void): void {
    this.createMethod(CinemaWsMethods.SeatStatusChanged, method);
  }
}
